import isEqual from "lodash/isEqual";
import { PureComponent } from "react";
import { Link } from "react-router-dom";

import { ColumnConfig, SortDirections, wafflesKeyColumnName } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { BasicRecord, BasicWaffle } from "./basicRecord";
import { SummaryResultNetworkType, SummaryResultType } from "./enumerations";

interface BasicTableProps {
  providersEndpointFunc: (networkType: SummaryResultNetworkType, resultType: SummaryResultType, key: string | number) => string;
  records: BasicRecord[];
  tableName: string;
}

interface BasicTableState {
  sortedRecords: BasicWaffle[];
}

export default class BasicTable extends PureComponent<BasicTableProps, BasicTableState> {
  private columnConfig: ColumnConfig;
  constructor(props: BasicTableProps) {
    super(props);
    this.state = {
      sortedRecords: this.buildRecords(),
    };

    this.columnConfig = {
      name: {
        displayText: this.props.tableName,
        testId: "name",
      },
      network: {
        displayText: "Network",
        testId: "network",
      },
      prospect: {
        displayText: "Prospect",
        hidden: !this.props.records.some((r) => !!r.prospect),
        testId: "prospect",
      },
    };
  }

  public componentDidUpdate(prevProps: BasicTableProps) {
    if (!isEqual(prevProps.records, this.props.records)) {
      this.setState({ sortedRecords: this.buildRecords() });
    }
  }

  public render() {
    return (
      <Waffles<BasicWaffle>
        data={this.state.sortedRecords}
        columns={this.columnConfig}
        customSort={this.customSort}
        loading={this.props.records.length === 0}
        testId={this.props.tableName.replace(/ /g, "-").toLowerCase()}
      />
    );
  }

  private buildRecords = () => {
    const builtData = this.props.records.map((r) => ({
      name: r.name as string,
      network: (r.network ? <Link key={r.network} to={`${this.props.providersEndpointFunc(SummaryResultNetworkType.Network, r.resultType, r.key)}`}>{(r.network).toLocaleString()}</Link> : <span>0</span>),
      prospect: (r.prospect ? <Link key={r.prospect} to={`${this.props.providersEndpointFunc(SummaryResultNetworkType.Prospect, r.resultType, r.key)}`}>{(r.prospect).toLocaleString()}</Link> : <span>0</span>),
      [wafflesKeyColumnName]: r.name.toString(),
    }));

    return builtData;
  }

  private customSort = (records: BasicWaffle[], column: keyof BasicWaffle, direction: SortDirections) => {
    const data = [...records];
    if (direction === SortDirections.None) {
      return data;
    }
    const multiplier = direction === SortDirections.Asc ? 1 : -1;
    switch (column) {
      case "name":
        return data.sort((a, b) => (a.name > b.name ? 1 : -1) * multiplier);
      case "network":
      case "prospect":
        return data.sort(
          (a, b) => {
            return ((parseInt(a[column].key) || 0) > (parseInt(b[column].key) || 0) ? 1 : -1) * multiplier;
          });
    }
  }
}

export { BasicTable };
